import { router, usePage } from "@inertiajs/react";
import type { ScoutExternalMode, SharedProps } from "@/types";

const MODES: ScoutExternalMode[] = ["fake", "record", "live"];

const PANEL_STYLES: Record<ScoutExternalMode, string> = {
  fake: "border-emerald-400 bg-emerald-50 text-emerald-950",
  record: "border-amber-400 bg-amber-50 text-amber-950",
  live: "border-sky-400 bg-sky-50 text-sky-950",
};

const BUTTON_ACTIVE: Record<ScoutExternalMode, string> = {
  fake: "bg-emerald-600 text-white",
  record: "bg-amber-600 text-white",
  live: "bg-sky-600 text-white",
};

export default function ScoutExternalModeOverlay() {
  const mode = usePage<SharedProps>().props.scout_external_mode;
  if (!mode) return null;

  function setMode(next: ScoutExternalMode) {
    if (next === mode) return;

    router.patch("/dev/scout_external_mode", { mode: next }, { preserveScroll: true });
  }

  return (
    <div
      className={`fixed bottom-4 right-4 z-100 rounded-lg border px-3 py-2 shadow-md ${PANEL_STYLES[mode]}`}
      data-testid="scout-external-mode-overlay"
    >
      <p className="mb-1.5 text-xs font-semibold uppercase tracking-wide opacity-80">ScoutExternal</p>
      <div className="flex gap-1">
        {MODES.map((option) => (
          <button
            key={option}
            type="button"
            className={`rounded px-2 py-1 text-xs font-medium ${
              option === mode ? BUTTON_ACTIVE[option] : "bg-white/70 hover:bg-white"
            }`}
            onClick={() => setMode(option)}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}
